import React, { useState } from "react";
import { IconButton, Button } from "@mui/material";
import { DataTable } from "../../components/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import { Column } from "../../types/Column";
import EditModal from "../../components/EditModal";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import AddModal from "../../components/AddModal";
import {
  addNewArmatekaSubject,
  fetchArmatekaSubjects,
  removeArmatekaSubject,
  updateArmatekaSubject,
  type ArmatekaSubject,
} from "../../api";
import DeleteDialog from "../../components/DeleteDialog";

const ArmatekaSubjectsPage = () => {
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isBanModalOpen, setBanModalOpen] = useState(false);
  const [currentData, setCurrentData] = useState<ArmatekaSubject | null>(null);
  const [isAddModalOpen, setAddModalOpen] = useState(false);

  const handleEditClick = (userData: ArmatekaSubject) => {
    setCurrentData(userData);
    setEditModalOpen(true);
  };

  const handleBanClick = (userData: ArmatekaSubject) => {
    setCurrentData(userData);
    setBanModalOpen(true);
  };

  // Handler for when the modal is closed without saving
  const handleClose = () => {
    setEditModalOpen(false);
    setBanModalOpen(false);
    setAddModalOpen(false);
  };

  // Handler for when the modal save action is performed
  const handleSave = (
    updatedData: Pick<ArmatekaSubject, "name" | "image" | "id">
  ) => {
    changeUser.mutate(updatedData);
    setEditModalOpen(false);
  };
  const handleConfirmBan = () => {
    if (!currentData) return;
    deleteUser.mutate(currentData.id);
    setBanModalOpen(false);
  };

  const handleAdd = (updateddata: Pick<ArmatekaSubject, "name" | "image">) => {
    addUser.mutate(updateddata);
    handleClose();
  };
  const columns: Column<ArmatekaSubject>[] = [
    {
      label: "id",
      render: (subject) => <>{subject.id}</>,
    },
    {
      label: "Тема",
      render: (subject) => <>{subject.name}</>,
    },
    {
      label: "Изображение",
      render: (subject) => (
        <img
          style={{ maxWidth: "100px", height: "auto" }}
          src={subject.image}
          alt={subject.name}
        />
      ),
    },
    {
      label: "Действия",
      render: (subject) => (
        <>
          <IconButton
            aria-label="edit"
            onClick={() => handleEditClick(subject)}
            key={subject.id}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            aria-label="block"
            onClick={() => handleBanClick(subject)}
          >
            <BlockIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const queryClient = useQueryClient();

  const { data, error, isLoading } = useQuery({
    queryKey: ["armateka-subjects"],
    queryFn: () => fetchArmatekaSubjects(),
  });

  const addUser = useMutation({
    mutationFn: addNewArmatekaSubject,
    mutationKey: ["armateka-subjects"],
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ["armateka-subjects"] }),
  });

  const deleteUser = useMutation({
    mutationFn: removeArmatekaSubject,
    mutationKey: ["armateka-subjects"],
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ["armateka-subjects"] }),
  });

  const changeUser = useMutation({
    mutationFn: updateArmatekaSubject,
    mutationKey: ["armateka-subjects"],
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ["armateka-subjects"] }),
  });

  if (isLoading) return <div>Loading...</div>;
  return (
    <div style={{ paddingLeft: "20px", paddingRight: "10px" }}>
      <h1>Темы</h1>
      <div style={{ marginBottom: "20px" }}>
        <Button onClick={() => setAddModalOpen(true)}>+Добавить</Button>
      </div>
      {error && <div>Error: {error.message}</div>}
      {data && <DataTable columns={columns} data={data} />}{" "}
      <AddModal
        open={isAddModalOpen}
        onClose={handleClose}
        title="Добавить вопрос"
        defaultState={{
          name: "",
          image: "",
        }}
        columns={[
          { label: "Тема", key: "name", editable: true, required: true },
          { label: "Изображение", key: "image", type: "file", required: true },
        ]}
        onSave={handleAdd}
      />
      {currentData && (
        <EditModal
          open={isEditModalOpen}
          onClose={handleClose}
          title="Редактирование вопроса"
          data={currentData}
          columns={[
            { label: "Тема", key: "name", editable: true, required: true },
            {
              label: "Изображение",
              key: "image",
              type: "file",
              required: true,
            },
          ]}
          onSave={handleSave}
        />
      )}
      <DeleteDialog
        open={isBanModalOpen}
        onClose={handleClose}
        onConfirm={handleConfirmBan}
        title="Удаление темы"
        text={`Вы точно хотите удалить тему
        ${currentData?.name}?`}
      />
    </div>
  );
};

export default ArmatekaSubjectsPage;
